module.exports = __webpack_public_path__ + "img/inventory.ebbab4c0.png";